(() => {
  const SELECTOR = '[data-pd-cart-shipping]';
  const DESTINATION = {
    country: 'Poland',
    zip: '00-001'
  };
  const MAX_POLLS = 10;
  const POLL_DELAY = 350;

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function money(cents, currency) {
    const locale = document.documentElement.lang || 'pl-PL';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'PLN',
        currencyDisplay: 'code'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (currency || 'PLN');
    }
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function shippingParams() {
    const params = new URLSearchParams();
    params.set('shipping_address[country]', DESTINATION.country);
    params.set('shipping_address[zip]', DESTINATION.zip);
    return params.toString();
  }

  async function fetchShippingRates() {
    const root = routesRoot();
    const params = shippingParams();

    const prepare = await fetch(root + 'cart/prepare_shipping_rates.json?' + params, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!prepare.ok && prepare.status !== 202) {
      throw new Error('Shipping rate preparation failed: ' + prepare.status);
    }

    for (let i = 0; i < MAX_POLLS; i += 1) {
      const response = await fetch(root + 'cart/async_shipping_rates.json?' + params, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Shipping rate lookup failed: ' + response.status);
      }

      const data = await response.json();
      if (data && Array.isArray(data.shipping_rates)) {
        return data.shipping_rates;
      }

      await sleep(POLL_DELAY);
    }

    throw new Error('Shipping rate lookup timed out');
  }

  function selectDpdRate(rates) {
    if (!rates.length) return null;

    return (
      rates.find((rate) => {
        const name = String(rate.presentment_name || rate.name || '').toLowerCase();
        return name.includes('dpd') && !name.includes('pobran');
      }) ||
      rates.find((rate) => {
        const name = String(rate.presentment_name || rate.name || '').toLowerCase();
        return name.includes('dpd');
      }) ||
      rates[0]
    );
  }

  function setFallback(container) {
    const shippingValue = container.querySelector('[data-pd-shipping-price]');
    const totalValue = container.querySelector('[data-pd-total]');
    const note = container.parentElement?.querySelector('[data-pd-shipping-note]');

    if (shippingValue) shippingValue.textContent = 'przy realizacji zakupu';
    if (totalValue) totalValue.textContent = 'po wyborze dostawy';
    if (note) note.textContent = 'Koszt dostawy zostanie potwierdzony w realizacji zakupu.';
  }

  async function hydrate(container) {
    if (!container || container.dataset.pdShippingState) return;
    container.dataset.pdShippingState = 'loading';

    const shippingValue = container.querySelector('[data-pd-shipping-price]');
    const totalValue = container.querySelector('[data-pd-total]');
    const shippingLabel = container.querySelector('[data-pd-shipping-label]');
    const note = container.parentElement?.querySelector('[data-pd-shipping-note]');

    if (container.dataset.requiresShipping === 'false') {
      const currency = container.dataset.currency || 'PLN';
      const cartTotal = Number(container.dataset.cartTotal || 0);

      if (shippingValue) shippingValue.textContent = money(0, currency);
      if (totalValue) totalValue.textContent = money(cartTotal, currency);
      if (note) note.textContent = 'Ten koszyk nie wymaga dostawy.';
      container.dataset.pdShippingState = 'success';
      return;
    }

    try {
      const rates = await fetchShippingRates();
      const rate = selectDpdRate(rates);
      if (!rate) throw new Error('No shipping rates returned');

      const currency = rate.currency || container.dataset.currency || 'PLN';
      const shippingCents = Math.round(Number.parseFloat(rate.price) * 100);
      const cartTotal = Number(container.dataset.cartTotal || 0);

      if (!Number.isFinite(shippingCents)) throw new Error('Invalid shipping rate');

      if (shippingLabel) {
        const rateName = String(rate.presentment_name || rate.name || 'DPD');
        shippingLabel.textContent = /dpd/i.test(rateName) ? 'Dostawa DPD' : 'Dostawa';
      }
      if (shippingValue) shippingValue.textContent = money(shippingCents, currency);
      if (totalValue) totalValue.textContent = money(cartTotal + shippingCents, currency);
      if (note) {
        const rateName = String(rate.presentment_name || rate.name || 'DPD');
        const displayName = /dpd/i.test(rateName) ? 'DPD' : rateName;
        note.textContent = 'Dostawa ' + displayName + ' na terenie Polski - ' + money(shippingCents, currency);
      }

      container.dataset.pdShippingState = 'success';
    } catch (error) {
      console.warn('[Projekt Dziecko] Nie udało się pobrać stawki dostawy:', error);
      setFallback(container);
      container.dataset.pdShippingState = 'error';
    }
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach((container) => hydrate(container));
  }

  function start() {
    scan();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
            scan();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
